import Vue from 'vue'
import App from './App.vue'
import router from './router'

import {
  $alert,
  $tips,
  $confirm,
  $hideLoading,
  $showLoading,
  $showBroadcast,
  $hideBroadcast,
  $message
} from './components/popupLayout'

Vue.config.productionTip = false
Vue.prototype.$cdn = 'https://shlmuseum.oss-cn-shanghai.aliyuncs.com/shls_museum/'

Vue.mixin({
  methods: {
    $alert,
    $tips,
    $confirm,
    $hideLoading,
    $showLoading,
    $showBroadcast,
    $hideBroadcast,
    $message
  }
})

let {axios} = require('./utils/http.js')

Vue.prototype.$http = axios
Vue.prototype.$bus = new Vue()


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
